module.exports = __webpack_public_path__ + "img/helisolo.60a479fb.jpg";